import { maskMobileInMessage } from "./Utils";

export const RECAPTCHA_SITE_KEY = "6Lei810pAAAAAL-HaSHvdad5f5VBl-aiil_YTJUS";

export const CAPTCHA_FIELD = "g_recaptcha_response";

export const sanitizeApiMessage = (message, fallback = "") =>
  maskMobileInMessage(message || fallback);

export const getApiErrorMessage = (error, fallback = "Something went wrong") =>
  sanitizeApiMessage(
    error?.response?.data?.message || error?.message,
    fallback
  );

export const withCaptchaPayload = (payload, captchaValue) => ({
  ...payload,
  [CAPTCHA_FIELD]: captchaValue,
});

/** Prefer live widget token; fall back to React state. */
export const getCaptchaToken = (recaptchaRef, captchaValue) => {
  const fromWidget = recaptchaRef?.current?.getValue?.();
  return fromWidget || captchaValue || "";
};

export const resetCaptcha = (recaptchaRef, setCaptchaValue) => {
  setCaptchaValue("");
  try {
    recaptchaRef?.current?.reset?.();
  } catch (e) {
    // ignore widget reset errors
  }
};
